const CONSTANTS = {
    DATE_FORMAT: 'MM/DD/YYYY',
    DATE_FORMAT_ISO_8601: 'YYYY-MM-DD',
    DATE_FORMAT_ISO_8601_WITH_HOURS_MIN_SEC : 'YYYY-MM-DD[T]HH:mm:ss.SSS',
    COUNT_DOWN_TIMER : {
      // If start time is not sent from the parent component,
      // the default start time is set to this value
      DEFAULT_START_TIME_SECONDS: 60,
  
      // If interval is not sent from the parent component,
      // the default interval is set to this value
      DEFAULT_INTERVAL_SECONDS:1
    },
    DIALOG: {
      CLOSE_REASON : [
        'escapeKeyDown',
        'backdropClick'
      ]
    }
  }
  
  export default CONSTANTS;